export const APP_PATH = "/app";

export const LOGIN_PATH = "login";
export const SIGNUP_PATH = "signup";
export const SURVEY_PATH = "survey";
export const MATCHING_PROCESS_PATH = "matching-process";
export const RESET_PASSWORD_PATH = "reset-password";

export const CANCEL_PATH = "cancel";
export const SUCCESS_PATH = "success";
export const VIDEO_PATH = "video";
export const BOOKING_PATH = "appointments/book";
export const APPOINTMENT_EDIT_PATH = "appointment-edit";
export const FEEDBACK_PATH = "feedback";
export const APPOINTMENTS_PATH = "appointments";
export const SETTINGS_PATH = "settings";
export const MESSAGES_PATH = "messages";
export const AVAILABILITY_PATH = "availability";

export const LANDING_PATH_SEARCH_DOCTOR = "/prenota-la-tua-visita";

export const appRoutes = {
  root: APP_PATH,

  // auth
  login: `${APP_PATH}/${LOGIN_PATH}`,
  signUp: `${APP_PATH}/${SIGNUP_PATH}`,
  survey: `${APP_PATH}/${SIGNUP_PATH}/${SURVEY_PATH}`,
  matchingProcess: `${APP_PATH}/${SIGNUP_PATH}/${MATCHING_PROCESS_PATH}`,
  resetPassword: `${APP_PATH}/${LOGIN_PATH}/${RESET_PASSWORD_PATH}`,

  // app
  feedback: `${APP_PATH}/${FEEDBACK_PATH}`,
  success: `${APP_PATH}/${SUCCESS_PATH}`,
  cancel: `${APP_PATH}/${CANCEL_PATH}`,
  appointments: `${APP_PATH}/${APPOINTMENTS_PATH}`,
  settings: `${APP_PATH}/${SETTINGS_PATH}`,
  messages: `${APP_PATH}/${MESSAGES_PATH}`,
  video: `${APP_PATH}/${VIDEO_PATH}`,
  appointmentBook: `${APP_PATH}/${BOOKING_PATH}`,
  appointmentEdit: `${APP_PATH}/${APPOINTMENT_EDIT_PATH}`,
  availability: `${APP_PATH}/${AVAILABILITY_PATH}`,
};
